import { call, put, takeLatest, select } from 'redux-saga/effects';
import * as Routines from '../Routines';
import { feedbackFailure } from '../../../Feedback/reducer';
import { AppAction, AppData, AppState } from '../../../Store/types';
import { DeviceSimpleSensor, FilterState } from '../types';
import * as Utils from '../../utils';
import { DeviceListActionTypes } from '../actionTypes';
import * as Api from '../api';
import { getDevices, getFilters, getDeviceTypes, getTwinSuffix, getPartnerDeviceList, getSensors } from '../selectors';
import { Option } from "@Elements/Dropdown/types";
import { selectCustomers, selectCurrentContext, selectMunicipalities, selectAppData } from '@Safemate/Store/selectors';
import { ICustomerWithPolicy } from '@Safemate/Model/Customer';
import { IDevice } from '@Safemate/Model/Device';
import { SiteTypeEnum } from '@Safemate/SiteTypeEnum';
import { saveFilters } from '../utils';

function* filterDevices(action: AppAction<null>){

  try {
    const devices: IDevice[] = yield select(getDevices);
    const sensors: DeviceSimpleSensor = yield select(getSensors);
    const filters: FilterState = yield select(getFilters);

    const currentContext: SiteTypeEnum = yield select(selectCurrentContext);
    const isAhp = currentContext === SiteTypeEnum.AHP;
    const customers: ICustomerWithPolicy[] = isAhp ? yield select(selectMunicipalities) : yield select(selectCustomers);
    const deviceTypes: Option[] = yield select(getDeviceTypes);
    const twinSuffix: string = yield select(getTwinSuffix);

    let filteredDevices = Utils.filterDevices(devices, sensors, filters, customers, deviceTypes, twinSuffix);
    if(filteredDevices.length == 0 && filters.search !== ""){
      filteredDevices = Utils.devicesSearchNoFilter(filters, sensors, devices);
      if(filteredDevices.length > 0){
        yield put(Routines.clearFilters.success());
      }
    }
    if(filteredDevices.length == 0 && filters.search != ""){
      const partnerDeviceList: IDevice[] = yield select(getPartnerDeviceList);
      const filteredPartnerDevices = Utils.filterPartnerDevices(filters, partnerDeviceList);
      yield put(Routines.filterPartnerDevices.success(filteredPartnerDevices));
    }

    yield put(Routines.filterDevices.success(filteredDevices));
    
    const appData: AppData = yield select(selectAppData);
    const roleId = appData.activeRoles.length > 0 ? appData.activeRoles[0].id : 0;
    const userId = appData.user.id;
    saveFilters(filters, roleId, userId);
  }
  catch(e){
    console.log(e)
    yield feedbackFailure(e);
    yield put(Routines.filterDevices.failure());
  }
}

function* filterPartnerDevices(action: AppAction<null>){
  try {
    const filters: FilterState = yield select(getFilters);
    const partnerDeviceList: IDevice[] = yield select(getPartnerDeviceList);
    const filteredPartnerDevices = Utils.filterPartnerDevices(filters, partnerDeviceList);
    yield put(Routines.filterPartnerDevices.success(filteredPartnerDevices));

    const appData: AppData = yield select(selectAppData);
    const roleId = appData.activeRoles.length > 0 ? appData.activeRoles[0].id : 0;
    const userId = appData.user.id;
    saveFilters(filters, roleId, userId);

  }
  catch(e){
    console.log(e)
    yield feedbackFailure(e);
    yield put(Routines.filterPartnerDevices.failure());
  }
}

function* filterSaga(){
    yield takeLatest(Routines.initialize.SUCCESS, filterDevices);
    yield takeLatest(Routines.updateDevice.SUCCESS, filterDevices);
    yield takeLatest(DeviceListActionTypes.FILTER_DEVICE_TYPE, filterDevices);
    yield takeLatest(DeviceListActionTypes.FILTER_ALARM, filterDevices);
    yield takeLatest(DeviceListActionTypes.FILTER_CUSTOMER, filterDevices);
    yield takeLatest(DeviceListActionTypes.FILTER_SEARCH, filterDevices);
    yield takeLatest(DeviceListActionTypes.FILTER_ORDER, filterDevices);
    yield takeLatest(DeviceListActionTypes.FILTER_USER_TAGS, filterDevices);
    yield takeLatest(Routines.searchSensors.SUCCESS, filterDevices);
    yield takeLatest(Routines.filterPartnerDevices.TRIGGER, filterPartnerDevices);
    yield takeLatest(Routines.getSensorsForUser.SUCCESS, filterDevices);
}

export default filterSaga;
